import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../src/components/DashboardLayout/DasboardLayout";
import { API_URL } from "../../../src/components/config";

const LowestTwentyCustomers = () => {
  const [customers, setCustomers] = useState([]);
  const [lowestCustomers, setLowestCustomers] = useState([]);

  const fetchCustomers = () => {
    Promise.all([
      fetch(`${API_URL}/customerdetails/`).then((res) => res.json()),
      fetch(`${API_URL}/rideshare/requests/all`).then((res) => res.json())
    ])
      .then(([data, rideshareRequestsData]) => {
        const rideshareRequests = Array.isArray(rideshareRequestsData) ? rideshareRequestsData : [];

        // `trips_requested` is a stored counter that only reflects private-trip activity —
        // fold in each customer's rideshare requests (matched via customerid, the same field
        // rideshare's passenger_id keys against) so low performers aren't miscounted.
        const withCombinedTrips = (data || []).map(customer => {
          const rideshareCount = rideshareRequests.filter(
            req => req.passenger_id === customer.customerid
          ).length;
          const baseTrips = parseInt(customer.trips_requested, 10) || 0;
          return {
            ...customer,
            rideshareCount,
            totalTripsRequested: baseTrips + rideshareCount
          };
        });

        const sorted = withCombinedTrips
          .filter(c => c.totalTripsRequested !== null && !isNaN(c.totalTripsRequested))
          .sort((a, b) => a.totalTripsRequested - b.totalTripsRequested)
          .slice(0, 20);
        setCustomers(withCombinedTrips);
        setLowestCustomers(sorted);
      })
      .catch((error) => console.error("Error fetching customers:", error));
  };

  useEffect(() => {
    fetchCustomers();
    const interval = setInterval(fetchCustomers, 30000);
    return () => clearInterval(interval);
  }, []);

  return (
    <DashboardLayout>
      <div className="p-6 bg-white dark:bg-gray-800 min-h-screen">
        <h1 className="text-3xl font-bold mb-6 text-[#8a1c1c] dark:text-white">
          Lowest 20 Performing Customers
        </h1>

        <div className="overflow-x-auto shadow-md rounded-lg">
          <table className="w-full text-sm text-left text-gray-700 dark:text-gray-300">
            <thead className="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-700 dark:text-gray-300">
              <tr>
                <th className="px-6 py-3">#</th>
                <th className="px-6 py-3">Customer ID</th>
                <th className="px-6 py-3">Full Name</th>
                <th className="px-6 py-3">Phone</th>
                <th className="px-6 py-3">Email</th>
                <th className="px-6 py-3">Username</th>
                <th className="px-6 py-3">Trips Requested</th>
                <th className="px-6 py-3">Membership Status</th>
              </tr>
            </thead>
            <tbody>
              {lowestCustomers.map((customer, index) => (
                <tr
                  key={customer.customerid}
                  className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
                >
                  <td className="px-6 py-4 font-semibold">{index + 1}</td>
                  <td className="px-6 py-4">{customer.customerid}</td>
                  <td className="px-6 py-4">{customer.name} {customer.surname}</td>
                  <td className="px-6 py-4">+{customer.phone}</td>
                  <td className="px-6 py-4">{customer.email || "N/A"}</td>
                  <td className="px-6 py-4">{customer.username}</td>
                  <td className="px-6 py-4 text-red-600 font-bold">{customer.totalTripsRequested}</td>
                  <td className="px-6 py-4">{customer.membershipstatus || "Unknown"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {lowestCustomers.length === 0 && (
          <div className="text-center py-4 text-gray-500 dark:text-gray-400">
            No customer data available.
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default LowestTwentyCustomers;
